
    import {Component, Vue} from 'vue-property-decorator';

    @Component
    export default class Navbar extends Vue {
        private error = false;
        private email = '';
        private partnerName = '';
        private showUserMenu = false;

        public mounted() {
            this.email = this.$store.getters.user;
            this.partnerName = this.$store.getters.partnerName;
        }

        private logout() {
            this.$store.dispatch('logout')
                .then(() => this.$router.push('/login'))
                .catch((err) => {
                    this.error = true;
                });
        }

        private openUserMenu() {
            this.showUserMenu = true;
        }

        private closeUserMenu() {
            this.showUserMenu = false;
        }

        private changePassword() {
            this.$router.push('/change-password');
        }
    }
